module.exports = __webpack_public_path__ + "img/matthieu.7bb3553e.svg";